export { baseAssetPath } from "./asset-path"
export {
  AudioFrameSource,
  defaultAudioFrameSourceOptions,
  defaultStreamOptions,
} from "./audio-frame-source"
export type {
  AudioFrameSourceOptions,
  FrameHandler,
  ProcessorType,
} from "./audio-frame-source"
export { defaultModelFetcher } from "./default-model-fetcher"
export {
  FrameProcessor,
  defaultFrameProcessorOptions,
  validateOptions,
} from "./frame-processor"
export type {
  FrameProcessorEvent,
  FrameProcessorOptions,
} from "./frame-processor"
export { loadModel } from "./load-model"
export type { LoadModelOptions, LoadedModel, ModelName } from "./load-model"
export { Message } from "./messages"
export type { Model, SpeechProbabilities } from "./models"
export { NonRealTimeVAD } from "./non-real-time-vad"
export type { NonRealTimeVADOptions } from "./non-real-time-vad"
import {
  arrayBufferToBase64,
  audioFileToArray,
  encodeWAV,
  minFramesForTargetMS,
} from "./utils"

export const utils = {
  audioFileToArray,
  minFramesForTargetMS,
  arrayBufferToBase64,
  encodeWAV,
}

export {
  DEFAULT_MODEL,
  MicVAD,
  getDefaultRealTimeVADOptions,
} from "./real-time-vad"
export type { RealTimeVADOptions } from "./real-time-vad"
